import { injectIntl, FormattedMessage } from 'react-intl';
import { isMobile } from 'react-device-detect';
import { PropTypes } from 'prop-types';

const ResourcesButtonGroup = (props) => {
  const { options, selected, handleButtonClick } = props;

  return (
    <div className={`tabFilters ${isMobile ? 'mobile' : ''}`}>
      {options.map(({ label, icon, id }) => (
        <button
          key={id}
          type='button'
          onClick={() => handleButtonClick(id)}
          className={`button button--small tabFilter-button ${id === selected ? 'selected' : ''}`}
        >
          {icon ? icon : null}
          <span>
            <FormattedMessage id={label} />
          </span>
        </button>
      ))}
    </div>
  );
};

ResourcesButtonGroup.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.object.isRequired,
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  selected: PropTypes.number.isRequired,
};

export default injectIntl(ResourcesButtonGroup);
